import { API_URL } from '../environment'
import qs from 'qs'

const fetchApi = (url, { query, ...options } = {}) => {
    const state = { Authorization: window.localStorage.getItem('token') }
    if (url.includes('/my/') && !state.Authorization) return
    let queryString = query ? qs.stringify(query) : ''
    const baseUrl =
        /^http/.test(url) || url.startsWith(API_URL)
            ? url
            : API_URL + '/' + url.replace(/^\//, '')
    const endpoint = queryString ? baseUrl + '?' + queryString : baseUrl
    return fetch(endpoint, {
        ...options,
        ...(options.body &&
            typeof options.body === 'object' && {
                body: JSON.stringify(options.body),
            }),
        headers: {
            'Content-Type': 'application/json',
            ...(state.Authorization && {
                Authorization: state.Authorization,
            }),
        },
    }).then(async (r) => {
        if (!r.ok) {
            const err = await r.json()
            if (err.name === 'TokenExpiredError') {
                state.Authorization = ''
                window.localStorage.removeItem('token')
                window.localStorage.removeItem('foobal_user')
                window.location.reload()
            }
            return Promise.reject(err)
        }
        const authResponseHeader = r.headers.get('Authorization')
        if (authResponseHeader) {
            window.localStorage.setItem('token', authResponseHeader)
            state.Authorization = authResponseHeader
        }
        return r.json()
    })
}
//    export const makeApiService = ()
export default fetchApi
